// extracted by mini-css-extract-plugin
export var rateTable = "_3u-0";